import React, { useCallback, useEffect, useRef, useState } from 'react'
import Grid from '@mui/material/Grid2';
import "../catalogs.css";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { faAngleRight, faChevronLeft, faChevronRight, faEye, faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import 'react-resizable/css/styles.css';
import { Modal, Tab, Tabs } from 'react-bootstrap';
import Select from 'react-select';
import { apiService } from '../../../../services/apiService';
import { toast } from 'react-toastify';
import { faCircleCheck, faFileLines } from '@fortawesome/free-regular-svg-icons';
import GeneralCaseCats from '../../../../components/catalog/GeneralCaseCats';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import AssignmentsGeneralCase from './BasicTabs/AssignmentsGeneralCase';
import GeneralCaseKnowledge from './BasicTabs/GeneralCaseKnowledge';
import GeneralCaseHistory from './BasicTabs/GeneralCaseHistory';
import dayjs from 'dayjs';
import CaseAllDetails from './BasicCaseTabs/CaseAllDetails';
import DiscussTaskCase from './BasicTabs/DiscussTaskCase';
import { AsyncPaginate } from 'react-select-async-paginate';
// import { Autocomplete, LoadScript } from '@react-google-maps/api';

// const libraries = ["places"];
function InProgress() {
    const userId = localStorage.getItem('userid');
    const [expanded, setExpanded] = useState(true);
    const navigate = useNavigate();
    const location = useLocation();
    const parts_location = location.pathname.split("/");
    const caseSlug = parts_location[2] || null;
    const taskId = parts_location[3] || null;
    const caseId = parts_location[4] || null;
    const [reloadChild, setReloadChild] = useState(0);
    const [activeTab, setActiveTab] = useState("overview");
    const [activeTabCase, setActiveTabCase] = useState("task");
    const [showCase, setShowCase] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const handleCloseSuccess = () => setShowSuccess(false);
    const [formData, setFormData] = useState({
        Q0010: '',
        Q0020: '',
        Q0030: '',
        Q0040: '',
        Q0050: '',
        Q0060: '',
        Q0080: '',
        Q0090: '',
        Q0100: '',
        Q0110: '',
        Q0130: '',
        Q0140: '',
    });
    const [errors, setErrors] = useState({});
    const [errorMessage, setErrorMessage] = useState('');
    const [submitloader, setSubmitloader] = useState(false);
    const [submitloader2, setSubmitloader2] = useState(false);

    const [reqList, setRequestList] = useState([]);
    const [ownerGroupList, setOwnerGroup] = useState([]);
    const [bussEntryList, setBussEntry] = useState([]);
    const [selectedBussEntry, setSelectedBussEntry] = useState(null);
    const [solutionsList, setSolutionList] = useState([]);
    const [selectedSolutions, setSelectedSolutions] = useState(null);
    const [caseTypeList, setCaseTypeList] = useState([]);
    const [selectedCaseType, setSelectedCaseType] = useState(null);
    const [caseSubTypeList, setCaseSubTypeList] = useState([]);
    const [selectedCaseSubType, setSelectedCaseSubType] = useState(null);
    const [ccOthersList, setCcOthersList] = useState([]);
    const [selectedRelKb, setSelectedRelKb] = useState(null);
    const [relCaseList, setRelCaseList] = useState([]);
    const [selectedRelCase, setSelectedRelCase] = useState(null);
    const [loading, setLoading] = useState(false);
    const [allData, setAllData] = useState([]);
    const [allDataSubmit, setAllDataSubmit] = useState([]);
    const [refetchData, setRefetchData] = useState(null);
    const [value, setValue] = useState(dayjs(null));

    const [showRefBack, setShowRefBack] = useState(false);
    const handleCloseRefBack = () => setShowRefBack(false);
    // const [paginatedata, setPaginateData] = useState({});
    // const [currentPage, setCurrentPage] = useState(1);
    const fetchFormData = useCallback(async () => {
        setLoading(true);
        try {
            const response = await apiService.getRequest(`/cases/${caseSlug}/${caseId}`);
            if (response && response.success === true) {
                setAllData(response.data);
                setAllDataSubmit(response);
                setShowCase(response.data?.can_see_case);
                setRefetchData(response.data.form_data);
                setFormData({
                    Q0010: response.data?.form_data?.Q0010?.raw_value || response.data?.triage_form_data?.Q0040?.raw_value,
                    Q0020: response.data?.form_data?.Q0020?.raw_value || response.data?.triage_form_data?.Q0050?.raw_value,
                    Q0030: response.data?.form_data?.Q0030?.raw_value || response.data?.triage_form_data?.Q0070?.raw_value,
                    Q0040: response.data?.form_data?.Q0040?.raw_value || response.data?.triage_form_data?.Q0080?.raw_value,
                    Q0050: response.data?.form_data?.Q0050?.raw_value || response.data?.triage_form_data?.Q0090?.raw_value,
                    Q0060: response.data?.form_data?.Q0060?.raw_value || response.data?.triage_form_data?.Q0100?.raw_value,
                    Q0080: response.data?.form_data?.Q0080?.raw_value,
                    Q0090: response.data?.form_data?.Q0090?.raw_value,
                    Q0100: response.data?.form_data?.Q0100?.raw_value,
                    Q0110: response.data?.form_data?.Q0110?.raw_value,
                    Q0130: response.data?.form_data?.Q0130?.raw_value,
                    Q0140: response.data?.form_data?.Q0140?.raw_value || response.data?.intake_form_data?.Q0100?.raw_value,
                })
                const selectedRelkbs = response.data?.form_data?.Q0130?.lookup_value?.items.map(relKb => ({
                    label: relKb.label,
                    value: relKb.id,
                }));
                setSelectedRelKb(selectedRelkbs);
                setFiles(response.data?.form_data?.Q0120?.raw_value || response.data?.triage_form_data?.Q0120?.raw_value || []);
                if (response.data?.form_data?.Q0080?.raw_value) {
                    const parsedDob = dayjs(response.data?.form_data?.Q0080?.raw_value, 'YYYY-MM-DD');
                    if (parsedDob.isValid()) {
                        setValue(parsedDob); 
                    }
                }
            }else{
                if(response.error === "permission_denied"){
                    toast.error(response.message || "Permission Denied")
                    navigate("/dashboard")
                }
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (error) {
            console.error('Error fetching tab data:', error);
        } finally {
            setLoading(false);
        }
    }, [caseSlug, caseId, navigate]);

    useEffect(() => {
        fetchFormData();
    }, [fetchFormData]);
    useEffect(() => {
        if (!formData) return;

        // Business Entry
        if (formData.Q0030 && bussEntryList.length > 0) {
            const selected = bussEntryList.find(x => x.value === Number(formData.Q0030));
            selected && setSelectedBussEntry(selected);
        }

        // Solutions Entry
        if (formData.Q0040 && solutionsList.length > 0) {
            const selected = solutionsList.find(x => x.value === Number(formData.Q0040));
            selected && setSelectedSolutions(selected);
        }

        // Case Entry
        if (formData.Q0050 && caseTypeList.length > 0) {
            const selected = caseTypeList.find(x => x.value === Number(formData.Q0050));
            selected && setSelectedCaseType(selected);
        }

        if (formData.Q0060 && caseSubTypeList.length > 0) {
            const selected = caseSubTypeList.find(x => x.value === Number(formData.Q0060));
            selected && setSelectedCaseSubType(selected);
        }
        if (formData && formData.Q0140 && relCaseList?.length > 0) {

            let values = [];

            const raw = formData.Q0140;

            if (Array.isArray(raw)) {
                values = raw.map(v => Number(v));
            } else if (typeof raw === "string") {
                values = raw.split(",").map(v => Number(v.trim()));
            } else if (typeof raw === "number") {
                values = [raw];
            } else {
                values = [];
            }

            const selectedRelCase = values
                .map(num => relCaseList.find(item => item.value === num))
                .filter(Boolean);

            setSelectedRelCase(selectedRelCase);
        }

    }, [formData, reqList, ccOthersList, ownerGroupList, bussEntryList, solutionsList, caseTypeList, caseSubTypeList, relCaseList]);
    
    useEffect(() => {
        if(allData?.status_string && allData.status_string !== "completed"){
            const fetchData = async () => {
                const response = await apiService.postRequest(`internal-users`);
                if (response.success) {
                    const options = response.data.map((role) => ({
                        value: role.id,
                        label: role.full_name,
                    }));
                    setRequestList(options);
                }
            };
            fetchData();
        }
    }, [allData]);
    useEffect(() => {
        if(allData?.status_string && allData.status_string !== "completed"){
            const fetchData = async () => {
                const response = await apiService.postRequest(`ownership-groups`);
                if (response.success) {
                    const options = response.data.map((role) => ({
                        value: role.id,
                        label: role.name,
                    }));
                    setOwnerGroup(options);
                }
            };
            fetchData();
        }
    }, [allData]);
    useEffect(() => {
        if(allData?.status_string && allData.status_string !== "completed"){
            const fetchData = async () => {
                const response = await apiService.postRequest(`case_holdings`);
                if (response.success) {
                    const options = response.data.map((role) => ({
                        value: role.id,
                        label: role.name,
                    }));
                    setBussEntry(options);
                }
            };
            fetchData();
        }
    }, [allData]);
    useEffect(() => {
        if(allData?.status_string && allData.status_string !== "completed" && (allData?.triage_form_data?.Q0060?.raw_value || allData?.case?.assignment_group_id)){
            const param ={
                ownership_group_id : allData?.triage_form_data?.Q0060?.raw_value || allData?.case?.assignment_group_id
            }
            const fetchData = async () => {
                const response = await apiService.postRequest(`general-case-stage-solutions/list`, param);
                if (response.success) {
                    const options = response.data.map((role) => ({
                        value: role.id,
                        label: role.name,
                    }));
                    setSolutionList(options);
                }
            };
            fetchData();
        }
    }, [allData]);
    useEffect(() => {
        if(selectedSolutions && allData?.status_string && allData.status_string !== "completed" && selectedSolutions?.value && (allData?.triage_form_data?.Q0060?.raw_value || allData?.case?.assignment_group_id)){
            const param ={
                ownership_group_id : allData?.triage_form_data?.Q0060?.raw_value || allData?.case?.assignment_group_id
            }
            const fetchData = async () => {
                const response = await apiService.postRequest(`case-types/list/${selectedSolutions && selectedSolutions.value}`, param);
                if (response.success) {
                    const options = response.data.map((role) => ({
                        value: role.id,
                        label: role.name,
                    }));
                    setCaseTypeList(options);
                }
            };
            fetchData();
        }
    }, [selectedSolutions, allData]);
    useEffect(() => {
        if(selectedCaseType && allData?.status_string && allData.status_string !== "completed" && selectedCaseType?.value){
            const fetchData = async () => {
                const response = await apiService.postRequest(`case-sub-types/list/${selectedCaseType && selectedCaseType.value}`);
                if (response.success) {
                    const options = response.data.map((role) => ({
                        value: role.id,
                        label: role.name,
                    }));
                    setCaseSubTypeList(options);
                }
            };
            fetchData();
        }
    }, [selectedCaseType, allData]);
    useEffect(() => {
        if(allData?.status_string && allData.status_string !== "completed"){
            const params = {
                'task_id' : Number(taskId)
            }
            const fetchData = async () => {
                const response = await apiService.postRequest(`cc-users`, params);
                if (response.success) {
                    const options = response.data.map((role) => ({
                        value: role.id,
                        label: role.email,
                    }));
                    setCcOthersList(options);
                }
            };
            fetchData();
        }
    }, [allData, taskId]);

    
    const loadOptions = async (searchQuery, loadedOptions, { page }) => {
        const params = {
            search: searchQuery,
            page : page
        }
        try {
        const response = await apiService.postRequest(
            `related-articles-dropdown`, params
        );
        if(response && response.success === true){
        return {
            options: response?.data?.map(item => ({
            value: item.id,
            label: item.kb_number,
            })),
            hasMore: response?.meta?.current_page === response?.meta?.last_page ? false : true,
            additional: {
            page: page + 1,
            },
        };
        }else{
            return {
                options: [],
                hasMore: false,
            };
        }} catch (error) {
        console.error('Error loading options:', error);
        return {
            options: [],
            hasMore: false,
        };
        }
    };

    useEffect(() => {
        if(selectedCaseType && allData){
            const fetchData = async () => {
            const param ={
                department_id : Number(allData?.triage_form_data?.Q0060?.raw_value) ,
                case_type_id : selectedCaseType?.value,
            }
            const response = await apiService.postRequest(`related-cases-dropdown`, param);
            if (response.success) {
                const options = response.data.map((role) => ({
                    value: role.id,
                    label: role.case_number,
                }));
                setRelCaseList(options);
            }
        };
        fetchData();
        }
    }, [selectedCaseType, allData]);
    
    const handleRelKb = (selectedOptions) => {
        setSelectedRelKb(selectedOptions); 
        
        const selectedValues = selectedOptions ? selectedOptions && selectedOptions.map(option => option.value) : [];
        
        setFormData((prevFormData) => ({
            ...prevFormData,
            Q0130: selectedValues,
        }));
        if (errors.Q0130) {
            setErrors({ ...errors, Q0130: '' });
        }
    };
    const handleRelCase = (selectedOptions) => {
        setSelectedRelCase(selectedOptions); 
        
        const selectedValues = selectedOptions ? selectedOptions && selectedOptions.map(option => option.value) : [];
        
        setFormData((prevFormData) => ({
            ...prevFormData,
            Q0140: selectedValues,
        }));
        if (errors.Q0140) {
            setErrors({ ...errors, Q0140: '' });
        }
    };
    const handleDateChange = (newValue) => {
        if (newValue) {
            setValue(newValue);
            setFormData({ ...formData, Q0080: newValue.format('YYYY-MM-DD') });
    
            // Clear the error for Q0080 if a valid date is entered
            if (errors.Q0080) {
                setErrors({ ...errors, Q0080: '' });
            }
        } else {
            setValue(null);
            setFormData({ ...formData, Q0080: '' }); // Clear the value if null
        }
    };

    const [filteredSuggestions, setFilteredSuggestions] = useState([]);
    const [activeIndex, setActiveIndex] = useState(-1);
    const [showSuggestions, setShowSuggestions] = useState(false);

    const fetchSuggestions = async (query) => {
        if (!query) {
            return;
        }
    
        try {
            const response = await apiService.postRequest("locations/suggestions", { "search": query , "type" : "case_management" });
            if(response && response.success){
            setFilteredSuggestions(response.data || [])
            //   setSuggestions(response.tags || []); // Adjust based on API response
            }else{
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (error) {
            console.error("Error fetching suggestions:", error);
        }
    };
    const handleInputSuggChange = (e) => {
        const value = e.target.value;
        setFormData({ ...formData, Q0020: value });
        if (value) {
            fetchSuggestions(value);
            setShowSuggestions(true);
        } else {
            setShowSuggestions(false);
        }
    };

    const handleSuggestionClick = (suggestion) => {
        setFormData({ ...formData, Q0020: suggestion });
        setShowSuggestions(false);
    };
    const handleKeyDown = (e) => {
        if (e.key === "ArrowDown" && activeIndex < filteredSuggestions.length - 1) {
            setActiveIndex(activeIndex + 1);
        } else if (e.key === "ArrowUp" && activeIndex > 0) {
            setActiveIndex(activeIndex - 1);
        } else if (e.key === "Enter") {
            if (activeIndex >= 0) {
                const selected = filteredSuggestions[activeIndex];
                setFormData({ ...formData, Q0020: selected.label });
                // setLocationQuery(e.target.value)
                setShowSuggestions(false);
            }
        }
    };
    const handleInputChange = (e) => {
        const { name, value } = e.target;
    
        // Clear the error for the specific field being modified
        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: '',
        }));
        setFormData({ ...formData, [name]: value });
    };

    const [files, setFiles] = useState([]);
    const fileInputRef = useRef(null);
    const MAX_FILES = 20;
    const MAX_TOTAL_SIZE_MB = 200;
    const MAX_FILE_SIZE_MB = 10;
    const MAX_VIDEO_SIZE_MB = 200; // Special limit for video files
    const allowedTypes = [
        'image/jpeg', 'image/png', 'image/gif',
        'image/bmp',                                                    // .bmp
        'application/pdf',
        'text/csv',
        'text/plain',
        'text/html',                                                    // .html
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.ms-excel',                                     // .xls
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
        'application/vnd.ms-powerpoint',                                // .ppt
        'application/vnd.openxmlformats-officedocument.presentationml.presentation', // .pptx
        'application/zip',                                              // .zip
        'application/x-zip-compressed',                                 // .zip (alternate MIME)
        'multipart/x-zip',                                              // .zip (alternate MIME)
        'message/rfc822',                                               // .mht (alternate MIME)
        'multipart/related',                                            // .mht
        'video/mp4',
        'video/webm',
        'video/ogg',
        'audio/mpeg',                                                   // .mp3
        'audio/mp3',                                                    // .mp3 (alternate MIME)
        'audio/wav',                                                    // .wav
        'audio/wave',                                                   // .wav (alternate MIME)
        'audio/x-wav',                                                  // .wav (alternate MIME)
    ];

    const videoTypes = ['video/mp4', 'video/webm', 'video/ogg'];

    const handleFileChange = (event) => {
        const selectedFiles = Array.from(event.target.files);

        // Check if total number of files exceeds limit
        if (files.length + selectedFiles.length > MAX_FILES) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                Q0120: `You can only upload up to ${MAX_FILES} files.`,
            }));
            return;
        }

        // Check each file size and type
        for (const file of selectedFiles) {
            // Check if it's a video file
            const isVideo = videoTypes.includes(file.type);
            const maxSize = isVideo ? MAX_VIDEO_SIZE_MB : MAX_FILE_SIZE_MB;
            
            if (file.size > maxSize * 1024 * 1024) {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    Q0120: isVideo 
                        ? `Video files must be less than ${MAX_VIDEO_SIZE_MB} MB.`
                        : `Each file must be less than ${MAX_FILE_SIZE_MB} MB.`,
                }));
                return;
            }
            
            if (!allowedTypes.includes(file.type)) {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    Q0120: `Only image files (JPEG, PNG, GIF, BMP), CSV, PDF, XLS, XLSX, PPT, PPTX, MP4, WEBM, OGG, MP3, WAV, TXT, DOC, DOCX, HTML, MHT and ZIP are allowed.`,
                }));
                return;
            }
        }

        // Check total combined size of all files (skip if any video file is present)
        const hasVideo = selectedFiles.some(file => videoTypes.includes(file.type)) || 
                        files.some(file => file.file && videoTypes.includes(file.file.type));
        
        if (!hasVideo) {
            const currentSize = files.reduce((acc, file) => acc + file.file?.size, 0);
            const newSize = selectedFiles.reduce((acc, file) => acc + file?.size, 0);
            if (currentSize + newSize > MAX_TOTAL_SIZE_MB * 1024 * 1024) {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    Q0120: `Total file size cannot exceed ${MAX_TOTAL_SIZE_MB} MB.`,
                }));
                return;
            }
        }
        
        setErrors((prevErrors) => ({
            ...prevErrors,
            Q0120: "",
        }));
        
        const updatedFiles = selectedFiles.map((file) => ({
            file,
            name: file.name,
        }));
        setFiles((prevFiles) => [...prevFiles, ...updatedFiles]);
        fileInputRef.current.value = null;
    };

    const handleDrop = (event) => {
        event.preventDefault();
        const droppedFiles = Array.from(event.dataTransfer.files);

        // Check if total number of files exceeds limit
        if (files.length + droppedFiles.length > MAX_FILES) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                Q0120: `You can only upload up to ${MAX_FILES} files.`,
            }));
            return;
        }

        // Check each file size and type
        for (const file of droppedFiles) {
            // Check if it's a video file
            const isVideo = videoTypes.includes(file.type);
            const maxSize = isVideo ? MAX_VIDEO_SIZE_MB : MAX_FILE_SIZE_MB;
            
            if (file.size > maxSize * 1024 * 1024) {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    Q0120: isVideo 
                        ? `Video files must be less than ${MAX_VIDEO_SIZE_MB} MB.`
                        : `Each file must be less than ${MAX_FILE_SIZE_MB} MB.`,
                }));
                return;
            }
            
            if (!allowedTypes.includes(file.type)) {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    Q0120: `Only image files (JPEG, PNG, GIF, BMP), CSV, PDF, XLS, XLSX, PPT, PPTX, MP4, WEBM, OGG, MP3, WAV, TXT, DOC, DOCX, HTML, MHT and ZIP are allowed.`,
                }));
                return;
            }
        }

        // Check total combined size of all files (skip if any video file is present)
        const hasVideo = droppedFiles.some(file => videoTypes.includes(file.type)) || 
                        files.some(file => file.file && videoTypes.includes(file.file.type));
        
        if (!hasVideo) {
            const currentSize = files.reduce((acc, file) => acc + file.file.size, 0);
            const newSize = droppedFiles.reduce((acc, file) => acc + file.size, 0);
            if (currentSize + newSize > MAX_TOTAL_SIZE_MB * 1024 * 1024) {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    Q0120: `Total file size cannot exceed ${MAX_TOTAL_SIZE_MB} MB.`,
                }));
                return;
            }
        }

        setErrors((prevErrors) => ({
            ...prevErrors,
            Q0120: "",
        }));
        
        const updatedFiles = droppedFiles.map((file) => ({
            file,
            name: file.name,
        }));
        setFiles((prevFiles) => [...prevFiles, ...updatedFiles]);
    };

    const [deletedFiles, setDeletedFiles] = useState([]);

    const handleRemoveFile = (index) => {
        const fileToRemove = files[index];
        
        // Check if this is an existing file (string) rather than a newly uploaded file (object with 'file' property)
        if (typeof fileToRemove === 'string' || (fileToRemove && !fileToRemove.file)) {
            // This is an existing file from the server, track it for deletion
            const fileName = typeof fileToRemove === 'string' ? fileToRemove : fileToRemove.name;
            setDeletedFiles(prev => [...prev, fileName]);
        }
        
        setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
        // Reset the file input to allow the same file to be uploaded again
        if (fileInputRef.current) {
            fileInputRef.current.value = null;
        }
    };

    const handleDragOver = (event) => {
        event.preventDefault();
    };
    const validateForm = () => {
        const newErrors = {};
        if (formData.Q0020 && formData.Q0020.length < 3) {
            newErrors.Q0020 = "Location must be at least 3 characters long.";
        }else if (formData.Q0020 && formData.Q0020.length > 200) {
            newErrors.Q0020 = 'Location be less than 200 characters long.';
        }
        if (formData.Q0100 && formData.Q0100.length < 10) {
            newErrors.Q0100 = "Resolution notes must be at least 10 characters long.";
        }else if (formData.Q0100 && formData.Q0100.length > 2000) {
            newErrors.Q0100 = 'Resolution notes be less than 2000 characters long.';
        }
        if(Number(userId) !== Number(allData?.case?.requested_by_id)){
            if (formData.Q0110 && formData.Q0110.length < 10) {
                newErrors.Q0110 = "Private work notes must be at least 10 characters long.";
            }else if (formData.Q0110 && formData.Q0110.length > 2000) {
                newErrors.Q0110 = 'Private work notes be less than 2000 characters long.';
            }
        }
        
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    const handleSubmit = async (e, status) => {
        e.preventDefault();
        if (!validateForm()) {
            setErrorMessage('Please fix the errors before proceeding.');
            return;
        }
        if(status === 'draft'){
            setSubmitloader2(true);
        }else{
            setSubmitloader(true);
        }
        try {
            const formDataToSend = new FormData();

            if (files && files.length > 0) {
                files
                .filter((file) => {
                    // Keep only items that are objects with a valid file property
                    return file && 
                        file.file && 
                        typeof file.file !== 'string' && 
                        file.file !== null && 
                        file.file !== undefined;
                })
                .forEach((file) => {
                    formDataToSend.append('Q0120[]', file.file);
                });
            }
            // Add other form fields
            for (const key in formData) {
                if (formData[key] !== undefined && formData[key] !== null && formData[key] !== '') {
                    formDataToSend.append(key, formData[key]);
                }
            }
            if (deletedFiles && deletedFiles.length > 0) {
                deletedFiles.forEach((fileName) => {
                    formDataToSend.append('deleted_files[]', fileName);
                });
            }

            if(status === 'draft'){
                formDataToSend.append('status', status);
            }else{
                formDataToSend.delete('status');
            }

            const response = await apiService.postRequest(`cases/${caseSlug}/${caseId}/submit`, formDataToSend);
            console.log("formDataToSend", formData)
            // Check if the response indicates success
            if (response && response.success === true) {
                setShowSuccess(true)
                setErrors({});
                setErrorMessage('');
                fetchFormData();
                setReloadChild(prev => prev + 1);
                toast(response.message || "Submitted Successfully !")
                setSuccessMessage(response.message || "Submitted Successfully !")
            } else {
                setErrorMessage(response.message || "Failed. Please try again");
                if (response.errors) {
                    setErrors(response.errors);
                }
            }
        } catch (error) {
            console.log("err",error);
        }finally {
            setSubmitloader(false); // Stop loader
            setSubmitloader2(false); // Stop loader
        }
    };


    const [formDataBack, setFormDataBack] = useState({
        Q0220 : '',
    });
    const [errorsBack, setErrorsBack] = useState({});

    const handleInputChangeBack = (e) => {
        const { name, value } = e.target;
    
        // Clear the error for the specific field being modified
        setErrorsBack((prevErrors) => ({
            ...prevErrors,
            [name]: '',
        }));
        setFormDataBack({ ...formDataBack, [name]: value });
    };
    const validateFormBack = (action) => {
        const newErrors = {};
        if(action === "route_back"){
            if (!formDataBack.Q0220) newErrors.Q0220 = "Reason  is required.";
        }
        setErrorsBack(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    const handleSubmitBack = async (e, action, Q0190) => {
        e.preventDefault();

        if (!validateFormBack(action, Q0190)) {
            setErrorMessage('Please fix the errors before proceeding.');
            return;
        }

        setSubmitloader(true);
        try {
            
            const jsonParams = {
                ...formData,...formDataBack,
                action,
                Q0190,
            };
            const response = await apiService.postRequest(`cases/${caseSlug}/${caseId}/submit`, jsonParams);

            // Check if the response indicates success
            if (response && response.success === true) {
                toast(response.message || "Submitted Successfully !");
                navigate("/task/my-cases");
            } else {
                setErrorMessage(response.message || "Failed. Please try again");
                if (response.errors) {
                    setErrors(response.errors);
                }
                if (response.errors?.Q0220){
                    setErrorsBack(response.errors);
                }
            }
        } catch (error) {
            console.log("err",error);
        }finally {
            setSubmitloader(false); // Stop loader
        }
    };

    const isLink = (file) => {
        const value = typeof file === "string" ? file : file?.name;
        return /^https?:\/\//i.test(value);
    };

    const sanitizeAndDisplayHTML = (html) => {
        if (!html) return '';
        const formattedHTML = html.replace(/\r\n|\r|\n/g, '<br />');
        return formattedHTML;
    };
  return (
    <div className='container-fluid px-0'>
        <div className="resizable-container d-flex">
            <GeneralCaseCats onReload={reloadChild}/>
            <div className='content_container_validate' style={{ flexGrow: 1 }}>
                <Grid size={{md:8,xs:12}} container flexDirection="column" className="jobseekerhead mb-3">
                    <span><b onClick={()=>navigate("/dashboard")}>Dashboard</b> 
                        <FontAwesomeIcon className='angleright' icon={faAngleRight} /> 
                        <b className="formatid_copyclip fw-bold text-decoration-none" style={{color:"#1A5298", width:"max-content"}}
                            onClick={async () => {
                                const url = `${window.location.origin}${allData?.case?.case_task_link}`;
                                const title = allData?.case?.gcase_summary?.short_description || "Case";
                                const textPlain = `${allData?.case?.case_formatted_id}: ${title}\n${url}`;
                                const textHtml = `<a href="${url}" target="_blank">${allData.case?.case_formatted_id}: ${title}</a>`;
                                try {
                                await navigator.clipboard.write([
                                    new ClipboardItem({
                                    "text/html": new Blob([textHtml], { type: "text/html" }),
                                    "text/plain": new Blob([textPlain], { type: "text/plain" }),
                                    }),
                                ]);
                                toast("Link copied to clipboard");
                                } catch (err) {
                                console.error("Failed to copy: ", err);
                                toast("Failed to copy link");
                                }
                            }}
                            >
                            {allData?.case?.case_formatted_id}
                        </b>
                        <FontAwesomeIcon className='angleright' icon={faAngleRight} />
                        <b className="formatid_copyclip fw-bold text-decoration-none" style={{color:"#1A5298", width:"max-content"}}
                            onClick={async () => {
                                const url = `${window.location.origin}${allData?.case?.case_task_link}`;
                                const title = allData?.case?.gcase_summary?.short_description || "Case";
                                const textPlain = `${allData?.task?.task_format_id} - ${allData?.case?.case_formatted_id}: ${title}\n${url}`;
                                const textHtml = `<a href="${url}" target="_blank">${allData?.task?.task_format_id} - ${allData.case?.case_formatted_id}: ${title}</a>`;
                                try {
                                await navigator.clipboard.write([
                                    new ClipboardItem({
                                    "text/html": new Blob([textHtml], { type: "text/html" }),
                                    "text/plain": new Blob([textPlain], { type: "text/plain" }),
                                    }),
                                ]);
                                toast("Link copied to clipboard");
                                } catch (err) {
                                console.error("Failed to copy: ", err);
                                toast("Failed to copy link");
                                }
                            }}
                            >
                            {allData?.task?.task_format_id}
                        </b>
                        </span>
                </Grid>
                <Grid size={{sm:12}} container className="main_jobseeker tab_controllers">
                    {loading ? 
                        <div className='d-flex justify-content-center w-100'>
                            <img style={{ width: "100px" }} src={require('../../../../assets/pinkloader.gif')} alt='Loading...' />
                        </div> :
                        <Grid size={{sm:12}} container justifyContent="space-between">
                            <Grid size={{ lg: expanded ? 7.4 : 11.5, md: expanded ? 7 : 11, xs: 12 }} sx={{ transition: "all 0.35s cubic-bezier(0.4,0,0.2,1)" }} container alignContent="flex-start">
                                <Tabs
                                    activeKey={activeTabCase}
                                    onSelect={(key) => setActiveTabCase(key)}
                                    defaultActiveKey="task"
                                    id="uncontrolled-tab-example" className="mb-4 drafttabs_tabs"
                                >
                                    <Tab eventKey="task" title="Task">
                                    <Grid size={{xs:12}} container justifyContent="space-between" className="jobseekerhead border_botomer mario_fixers">
                                        <Grid container flexDirection="column">
                                            <h3>Department Action<small className='small_headingstatuses'>{allData?.task?.status}</small></h3>
                                            <span>General Case</span>
                                        </Grid>
                                    </Grid>
                                    <Grid size={{sm:12}} container>
                                        <Grid size={{xs:12}} container flexDirection="column" justifyContent="center" className={`tab_controllers ${ expanded && "control_splits"}`}>
                                            <Tabs
                                                activeKey={activeTab}
                                                onSelect={(key) => setActiveTab(key)}
                                                defaultActiveKey="overview"
                                                id="uncontrolled-tab-example" className="drafttabs_tabs mt-4"
                                                >
                                                <Tab eventKey="overview" title="Overview" className={`${ expanded && "expanded-grid"}`}>
                                                    {allData && allData.status_string !== "completed" ?
                                                    <Grid size={{sm:12}} container alignItems="center">
                                                        <form className='w-100 pt-4' >
                                                            <Grid size={{lg:12,xs:12}} container justifyContent="space-between" className="regiter_inputs i94validateinput">
                                                                <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                                    <span>Requested By<small className='red_starimpo'>*</small></span>
                                                                    <input value={allData?.case?.requested_by_name} disabled />
                                                                </Grid>
                                                                <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                                    <span>Requested For<small className='red_starimpo'>*</small></span>
                                                                    <input value={allData?.case?.requested_for_name} disabled/>
                                                                </Grid>
                                                                <Grid size={{md:5.5, sm:5.8, xs:12}} container flexDirection="column">
                                                                    <span>Re-assignment Count <span style={{color:"red"}}> *</span></span>
                                                                    <input value={allData?.case?.reassignment_count} disabled/>
                                                                </Grid>
                                                                <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                                    <span>Impact<span style={{color:"red"}}> *</span></span>
                                                                    <select value={formData.Q0010} name='Q0010' onChange={handleInputChange} >
                                                                        <option value="">Select</option>
                                                                        <option value="P1">Enterprise wide</option>
                                                                        <option value="P2">Mutliple users</option>
                                                                        <option value="P3">Single user</option>
                                                                    </select>
                                                                    {errors.Q0010 && <p style={{color:"Red"}}>{errors.Q0010}</p>}
                                                                </Grid>
                                                                <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                                    <span>Location</span>
                                                                    <div className='col-12 px-0' style={{position:"relative"}}>
                                                                        <input type='text' placeholder='City and State'
                                                                            value={formData.Q0020}
                                                                            onChange={handleInputSuggChange}
                                                                            onKeyDown={handleKeyDown}
                                                                            onBlur={() => setTimeout(() => setShowSuggestions(false), 200)}
                                                                            onFocus={() => setShowSuggestions(true)}
                                                                        />
                                                                        {showSuggestions && (
                                                                            <ul className="suggestions-dropdown">
                                                                                {filteredSuggestions.length > 0 ? (
                                                                                    filteredSuggestions.map((suggestion, index) => (
                                                                                        <li
                                                                                            key={index}
                                                                                            className={index === activeIndex ? "active" : ""}
                                                                                            onMouseDown={() => handleSuggestionClick(suggestion.label)}
                                                                                        >
                                                                                            {suggestion.label}
                                                                                        </li>
                                                                                    ))
                                                                                ) : (
                                                                                    <li className="no-suggestions">No results found</li>
                                                                                )}
                                                                            </ul>
                                                                        )}
                                                                    </div>
                                                                    {errors.Q0020 && <p style={{color:"Red"}}>{errors.Q0020}</p>}
                                                                </Grid>
                                                                <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                                    <span>Business Entity<span style={{color:"red"}}> *</span></span>
                                                                    <Select
                                                                        // isDisabled={!showgroupselect || !showSubmits}
                                                                        className="basic-single select_withsearch"
                                                                        classNamePrefix="select"
                                                                        value={selectedBussEntry}
                                                                        defaultValue={null}
                                                                        name="Q0030"
                                                                        options={bussEntryList}
                                                                        onChange={(selectedOption) => {
                                                                            setSelectedBussEntry(selectedOption);
                                                                            handleInputChange({
                                                                                target: {
                                                                                    name: "Q0030",
                                                                                    value: selectedOption ? selectedOption.value : ""
                                                                                }
                                                                            });
                                                                        }}
                                                                    />
                                                                    {errors.Q0030 && <p style={{color:"Red"}}>{errors.Q0030}</p>}
                                                                </Grid>
                                                                <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                                    <span>Solution<span style={{color:"red"}}> *</span></span>
                                                                    <Select
                                                                        // isDisabled={!showgroupselect || !showSubmits}
                                                                        className="basic-single select_withsearch"
                                                                        classNamePrefix="select"
                                                                        value={selectedSolutions}
                                                                        defaultValue={null}
                                                                        name="Q0040"
                                                                        options={solutionsList}
                                                                        onChange={(selectedOption) => {
                                                                            setSelectedSolutions(selectedOption);
                                                                            setSelectedCaseType(null);
                                                                            setSelectedCaseSubType(null);
                                                                            
                                                                            setErrors((prevErrors) => ({
                                                                                ...prevErrors,
                                                                                Q0040: '',
                                                                            }));
                                                                            
                                                                            setFormData((prevFormData) => ({
                                                                                ...prevFormData,
                                                                                Q0040: selectedOption ? selectedOption.value : "",
                                                                                Q0050: "",
                                                                                Q0060: ""
                                                                            }));
                                                                        }}
                                                                    />
                                                                    {errors.Q0040 && <p style={{color:"Red"}}>{errors.Q0040}</p>}
                                                                </Grid>
                                                                {solutionsList &&
                                                                <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                                    <span>Case Type<span style={{color:"red"}}> *</span></span>
                                                                    <Select
                                                                        // isDisabled={!showgroupselect || !showSubmits}
                                                                        className="basic-single select_withsearch"
                                                                        classNamePrefix="select"
                                                                        value={selectedCaseType}
                                                                        defaultValue={null}
                                                                        name="Q0050"
                                                                        options={caseTypeList}
                                                                        onChange={(selectedOption) => {
                                                                            setSelectedCaseType(selectedOption);
                                                                            setSelectedCaseSubType(null);
                                                                            
                                                                            setErrors((prevErrors) => ({
                                                                                ...prevErrors,
                                                                                Q0050: '',
                                                                            }));
                                                                            
                                                                            setFormData((prevFormData) => ({
                                                                                ...prevFormData,
                                                                                Q0050: selectedOption ? selectedOption.value : "",
                                                                                Q0060: ""
                                                                            }));
                                                                        }}
                                                                    />
                                                                    {errors.Q0050 && <p style={{color:"Red"}}>{errors.Q0050}</p>}
                                                                </Grid>}
                                                                {selectedCaseType &&
                                                                <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                                    <span>Case Sub Type<span style={{color:"red"}}> *</span></span>
                                                                    <Select
                                                                        // isDisabled={!showgroupselect || !showSubmits}
                                                                        className="basic-single select_withsearch"
                                                                        classNamePrefix="select"
                                                                        value={selectedCaseSubType}
                                                                        defaultValue={null}
                                                                        name="Q0060"
                                                                        options={caseSubTypeList}
                                                                        onChange={(selectedOption) => {
                                                                            setSelectedCaseSubType(selectedOption);
                                                                            handleInputChange({
                                                                                target: {
                                                                                    name: "Q0060",
                                                                                    value: selectedOption ? selectedOption.value : ""
                                                                                }
                                                                            });
                                                                        }}
                                                                    />
                                                                    {errors.Q0060 && <p style={{color:"Red"}}>{errors.Q0060}</p>}
                                                                </Grid>}
                                                                <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                                    <span>Due Date<span style={{color:"red"}}> *</span></span>
                                                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                        <DatePicker
                                                                            className="date_pickermux"
                                                                            value={value}
                                                                            onChange={handleDateChange}
                                                                            minDate={dayjs().add(1, 'day')}
                                                                            renderInput={(params) => <input {...params} />}
                                                                        />
                                                                    </LocalizationProvider>
                                                                    {errors.Q0080 && <p style={{color:"Red"}}>{errors.Q0080}</p>}
                                                                </Grid>
                                                                <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                                    <span>Resolution Code<span style={{color:"red"}}> *</span></span>
                                                                    <select name="Q0090" value={formData.Q0090} onChange={handleInputChange}>
                                                                        <option value="">Select</option>
                                                                        <option value="Fulfillment Complete">Fulfillment Complete</option>
                                                                        <option value="Fulfillment In-Complete">Fulfillment In-Complete</option>
                                                                        <option value="Cancelled">Cancelled</option>
                                                                        <option value="Workaround">Workaround</option>
                                                                        <option value="Other">Other</option>
                                                                    </select>
                                                                    {errors.Q0090 && <p style={{color:"Red"}}>{errors.Q0090}</p>}
                                                                </Grid>
                                                                <Grid size={{xs:12}} container flexDirection="column" className="coustom_textarea">
                                                                    <span>Resolution Notes<span style={{color:"red"}}> *</span></span>
                                                                    <textarea maxLength={4001} name='Q0100' value={formData.Q0100} onChange={handleInputChange}/>
                                                                    {errors.Q0100 && <p style={{color:"Red"}}>{errors.Q0100}</p>}
                                                                </Grid>
                                                                {Number(userId) !== Number(allData?.case?.requested_by_id) &&
                                                                <Grid size={{xs:12}} container flexDirection="column" className="coustom_textarea">
                                                                    <span>Private work Notes<span style={{color:"red"}}> *</span></span>
                                                                    <textarea maxLength={4001} value={formData.Q0110} name='Q0110' onChange={handleInputChange}/>
                                                                    {errors.Q0110 && <p style={{color:"Red"}}>{errors.Q0110}</p>}
                                                                </Grid>}
                                                                
                                                                <Grid size={{xs:12}} container flexDirection="column">
                                                                    <span>Attachments</span>
                                                                    <Grid size={{xs: 12 }} container justifyContent="space-between">
                                                                        <div
                                                                            onDrop={handleDrop}
                                                                            onDragOver={handleDragOver}
                                                                            className='drag_uploaders align-items-center flex-column d-flex'
                                                                        >
                                                                            <FontAwesomeIcon className='file_uploadericon' icon={faFileLines} />
                                                                            <input
                                                                                type="file"
                                                                                multiple
                                                                                onChange={handleFileChange}
                                                                                style={{ display: 'none' }}
                                                                                id="file-upload"
                                                                                ref={fileInputRef} // Attach the ref here
                                                                            />
                                                                            <label htmlFor="file-upload">
                                                                                Browse Files
                                                                            </label>
                                                                            <p className='w-100 mb-0 mt-3'>or drop file here</p>
                                                                        </div>
                                                                        {errors.Q0120 && <div style={{ color: 'red', margin: '10px 0px' }}>{errors.Q0120}</div>}
                                                                    </Grid>
                                                                    <Grid size={{xs:12}} container justifyContent="space-between" className="mt-4">
                                                                        {files.map((file, index) => (
                                                                            <Grid key={index} size={{xs:12}} container justifyContent="space-between" alignItems="center" className="tablelisterattach reportincident">
                                                                                <Grid container className="pinkbgattachreport" alignItems="center">
                                                                                    <span className='spanreport_elipse' style={{whiteSpace: "nowrap"}}>{index + 1}<span className='filenamesshow ms-3'>{file.name || file}</span></span>
                                                                                    <button type="button" onClick={(e) => handleRemoveFile(index)}>
                                                                                        <FontAwesomeIcon icon={faXmark} />
                                                                                    </button>
                                                                                    {isLink(file) && (
                                                                                        <Link className='d-flex' to={`${file}`} target='_blank'>
                                                                                            <FontAwesomeIcon style={{fontSize:"medium"}} icon={faEye} />
                                                                                        </Link>
                                                                                    )}
                                                                                </Grid>
                                                                            </Grid>
                                                                        ))}
                                                                    </Grid>
                                                                </Grid>
                                                                <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                                    <span>Related Knowledge Articles</span>
                                                                    <AsyncPaginate
                                                                        isMulti
                                                                        closeMenuOnSelect={false}
                                                                        className="basic-single select_withsearch"
                                                                        classNamePrefix="select"
                                                                        loadOptions={loadOptions}
                                                                        value={selectedRelKb}
                                                                        placeholder="Select"
                                                                        additional={{
                                                                            page: 1,
                                                                        }}
                                                                        debounceTimeout={300}
                                                                        onChange={handleRelKb}
                                                                        cacheUniqs={[]}
                                                                        reduceOptions={(prevOptions, loadedOptions) => [...prevOptions, ...loadedOptions]} 
                                                                    />
                                                                    {errors.Q0130 && <p style={{color:"Red"}}>{errors.Q0130}</p>}
                                                                </Grid>
                                                                <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                                    <span>Related Cases</span>
                                                                    <Select
                                                                        isMulti
                                                                        // isDisabled={!showgroupselect || !showSubmits}
                                                                        className="basic-single select_withsearch"
                                                                        classNamePrefix="select"
                                                                        value={selectedRelCase}
                                                                        defaultValue={null}
                                                                        name="Q0140"
                                                                        options={relCaseList}
                                                                        onChange={handleRelCase}
                                                                    />
                                                                    {errors.Q0140 && <p style={{color:"Red"}}>{errors.Q0140}</p>}
                                                                </Grid>
                                                                {errorMessage && <div style={{ color: 'red', margin: '10px 0px' }}>{errorMessage}</div>}
                                                                {allDataSubmit?.can_submit === true &&
                                                                <Grid size={{sm:12, xs:12}} container className="mt-2 consplit_btns gap-3">
                                                                    <button type="button" onClick={() => setShowRefBack(true)} className='registersendbtn1'>Route Back</button>
                                                                    <button type="button" className='registersendbtn1' onClick={(e) => handleSubmit(e, "draft")}>{submitloader2 ? <img src={require('../../../../assets/pinkloader.gif')} alt=''/> : 'Save As Draft'}</button>
                                                                    <button type="button" className='registersendbtn2' onClick={(e) => handleSubmit(e, "")}>{submitloader && !showRefBack ? <img src={require('../../../../assets/whiteloader.gif')} alt=''/> : 'Submit'}</button>
                                                                </Grid>}
                                                            </Grid>
                                                        </form>
                                                    </Grid>:
                                                    <Grid size={{sm:12}} container alignItems="center">
                                                        <Grid size={{lg:12,xs:12}} container justifyContent="space-between" className="regiter_inputs i94validateinput">
                                                            <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                                <span>Requested By</span>
                                                                <p>{allData?.case?.requested_by_name}</p>
                                                            </Grid>
                                                            <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                                <span>Requested For</span>
                                                                <p>{allData?.case?.requested_for_name}</p>
                                                            </Grid>
                                                            <Grid size={{md:5.5, sm:5.8, xs:12}} container flexDirection="column">
                                                                <span>Re-assignment Count</span>
                                                                <p> {allData?.case?.reassignment_count} </p>
                                                            </Grid>
                                                            <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                                <span>Impact</span>
                                                                <p>{refetchData?.Q0010?.display_value}</p>
                                                            </Grid>
                                                            {refetchData?.Q0020?.display_value &&
                                                            <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                                <span>Location</span>
                                                                <p>{refetchData?.Q0020?.display_value}</p>
                                                            </Grid>}
                                                            <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                                <span>Business Entity</span>
                                                                <p>{refetchData?.Q0030?.display_value}</p>
                                                            </Grid>
                                                            <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                                <span>Solution</span>
                                                                <p>{refetchData?.Q0040?.display_value}</p>
                                                            </Grid>
                                                            <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                                <span>Case Type</span>
                                                                <p>{refetchData?.Q0050?.display_value}</p>
                                                            </Grid>
                                                            <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                                <span>Case Sub Type</span>
                                                                <p>{refetchData?.Q0060?.display_value}</p>
                                                            </Grid>
                                                            <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                                <span>Due Date</span>
                                                                <p>{refetchData?.Q0080?.display_value || "No Data"}</p>
                                                            </Grid>
                                                            <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                                <span>Resolution Code</span>
                                                                <p>{refetchData?.Q0090?.display_value || "No Data"}</p>
                                                            </Grid>
                                                            <Grid size={{xs:12}} container flexDirection="column">
                                                                <span>Resolution Notes</span>
                                                                <p className='w-100' dangerouslySetInnerHTML={{ __html: sanitizeAndDisplayHTML(refetchData?.Q0100?.display_value || "No Data") }} />
                                                            </Grid>
                                                            {refetchData?.Q0110?.display_value &&
                                                            <Grid size={{xs:12}} container flexDirection="column">
                                                                <span>Private Work Notes</span>
                                                                <p className='w-100' dangerouslySetInnerHTML={{ __html: sanitizeAndDisplayHTML(refetchData?.Q0110?.display_value || "No Data") }} />
                                                            </Grid>}
                                                            {refetchData?.Q0120?.display_value?.length > 0 &&
                                                            <Grid size={{xs:12}} container flexDirection="column">
                                                                <span>Attachments</span>
                                                                <Grid size={{xs:12}} container justifyContent="space-between">
                                                                    {refetchData?.Q0120?.display_value.map((file, index) => (
                                                                        <span className='mt-2' key={index}>{index +1}. <Link to={`${file}`} target='_blank'>View</Link></span>
                                                                    ))}
                                                                </Grid>
                                                            </Grid>}
                                                            {refetchData?.Q0130?.display_value && Array.isArray(refetchData.Q0130.display_value) && refetchData.Q0130.display_value.length > 0 &&
                                                            <Grid size={{xs:12}} container flexDirection="column">
                                                                <span>Related Knowledge Articles</span>
                                                                {refetchData?.Q0130?.display_value.map((tag, index) => (
                                                                        <p className='mb-1 mt-0' key={index}>{tag}</p>
                                                                    ))
                                                                }
                                                            </Grid>}
                                                            {refetchData?.Q0140?.display_value && Array.isArray(refetchData.Q0140.display_value) && refetchData.Q0140.display_value.length > 0 &&
                                                            <Grid size={{xs:12}} container flexDirection="column">
                                                                <span>Related Cases</span>
                                                                {refetchData?.Q0140?.display_value.map((tag, index) => (
                                                                        <p className='mb-1 mt-0' key={index}>{tag}</p>
                                                                    ))
                                                                }
                                                            </Grid>}
                                                        </Grid>
                                                    </Grid>}
                                                </Tab>
                                                <Tab eventKey="assignment" title="Assignments">
                                                    {activeTab === "assignment" && <AssignmentsGeneralCase />}
                                                </Tab>
                                                <Tab eventKey="knowledge" title="Knowledge">
                                                    {activeTab === "knowledge" && <GeneralCaseKnowledge />}
                                                </Tab>
                                                <Tab eventKey="history" title="History" style={{ flexGrow: 1 }}>
                                                    {activeTab === "history" && <GeneralCaseHistory />}
                                                </Tab>
                                            </Tabs>
                                        </Grid>
                                    </Grid>
                                </Tab>
                                    {showCase && 
                                    <Tab eventKey="case" title="Case">
                                        {activeTabCase === "case" && <CaseAllDetails expanded={expanded}/>}
                                    </Tab>
                                    }
                                </Tabs>
                            </Grid>
                            <Grid alignContent="flex-start" size={{ lg: expanded ? 4.4 : 0.5, md: expanded ? 4.8 : 0.4, xs: 12, }} container className="border-start ps-3" sx={{ transition: "all 0.35s cubic-bezier(0.4,0,0.2,1)", overflow: "hidden", minWidth: expanded ? undefined : 0, }}>
                                <button onClick={() => setExpanded((prev) => !prev)} className='main_expanddisbtn'>
                                    {expanded ? <FontAwesomeIcon icon={faChevronRight} /> : <FontAwesomeIcon icon={faChevronLeft} />}
                                </button>
                                <Grid size={{xs:12}} container className={ expanded ? "" : "d-none"}>
                                    <DiscussTaskCase showCase={showCase} casediscuss={allData?.case?.is_requester}/>
                                </Grid>
                            </Grid>
                        </Grid>}
                </Grid>
                <Modal
                    show={showRefBack} 
                    onHide={handleCloseRefBack}
                    size="md"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    >
                    <Modal.Header closeButton style={{border:"none"}}>
                        <h5 className='modal_pinkheader'>Route Back</h5>
                    </Modal.Header>
                    <Modal.Body>
                        <form className='d-flex flex-column roleback_mainmodal'>
                            <div className='d-flex flex-column rollback_textarea'>
                                <span className='mt-0'>Enter a reason to Route Back <small className='justify_astrickt'>*</small></span>
                                <textarea maxLength={4001} name='Q0220' value={formDataBack.Q0220} onChange={handleInputChangeBack}/>
                                {errorsBack.Q0220 && <p style={{color:"Red"}}>{errorsBack.Q0220}</p>}
                                {errorMessage && <p style={{ color: 'red', margin: '10px 0px' }}>{errorMessage}</p>}
                            </div>
                            <div className='d-flex justify-content-end'>
                                <button type='submit' className='registersendbtn2 mb-2 ' onClick={(e) => handleSubmitBack(e, "route_back", "Route Back")}>
                                    {submitloader ? <img src={require('../../../../assets/whiteloader.gif')} alt=''/> : 'Submit'}
                                </button>
                            </div>
                        </form>
                    </Modal.Body>
                </Modal>
                <Modal
                    show={showSuccess} 
                    onHide={handleCloseSuccess}
                    size="md"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    >
                    <Modal.Header closeButton style={{border:"none"}}>
                        
                    </Modal.Header>
                    <Modal.Body>
                        <div className='d-flex w-100 text-center flex-column align-items-center modal_register'>
                            <FontAwesomeIcon className='main_tickiconpopup' icon={faCircleCheck} />
                            <h3>Successfully!</h3>
                            <small>{successMessage}</small>
                            <button onClick={handleCloseSuccess}>OK</button>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        </div>
    </div>
  )
}

export default InProgress
